import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { MissionsApi } from "@socotec.io/atm-back-sdk";
import { sdkDatesToStrings, sdkStringsToDates } from "@/api/utils/sdk";

const api = new MissionsApi(atmBackConfiguration);

const MISSION_DATES = ["dateRdv", "rfctDate"];
const normalizeMissionDates = (mission) => sdkDatesToStrings(mission, { dates: MISSION_DATES });

export const fetchMissions = async ({ case: caseUuid, offerItemStatus, page, pageSize } = {}) => {
  const response = await api.list({
    _case: caseUuid,
    offerItemStatus,
    page,
    pageSize,
  });
  response.results = response.results.map(normalizeMissionDates);
  return response;
};

/**
 * @param {object} missionData must carry `uuid`; only the 5 ATM-owned fields are written
 * @returns {Promise<object>} the updated mission (full read representation)
 */
export const updateMission = async (missionData) => {
  const { uuid, ...rest } = missionData;
  const patchedMissionWrite = sdkStringsToDates(rest, MISSION_DATES);
  const response = await api.partialUpdate({
    uuid,
    patchedMissionWriteRequest: patchedMissionWrite,
  });
  return normalizeMissionDates(response);
};
